/**
 * 画面名記録用ファイル
 */
// tslint:disable-next-line:no-namespace
export namespace ScreenName {
    /** 統括メニュー */
    export const MENU: string = 'menu';
    /** ログイン */
    export const ORDER_LOGIN: string = 'no_auth/OrderLogin';

    export const ACCEPTER_LOGIN: string = 'no_auth/accepterLogin';
    /** ログアウト */
    export const LOGOUT: string = 'no_auth/logout';

}
